export const NEXT_EVENT_PREFIX = {
  standard: 'Next event starts in',
  assessment: 'Next event due in',
};
